import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type SkillAnalyticsType } from './skillAnalytics';
import META from './useTrackSkillDeleted.meta';

export type UseTrackSkillDeletedParams = {
  scope: 'builtIn' | 'private' | 'workspace';
  skill_id: string;
  type: SkillAnalyticsType;
};

export const useTrackSkillDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillDeleted = useCallback(
    (params: UseTrackSkillDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillDeleted };
};
